import { useEffect, useState } from "react";
import TableWithInputsAndFilter from "../Tabellen/TableWithInputsAndFilter";
import DatenLaden from "../Tabellen/DatenLaden";
import { CSVLink } from "react-csv";
import KeineDaten from "../Tabellen/KeineDaten";


export default function DatenerfassungTabelle({
    loading, tableData, noData, deleteSpecificRow, nameOfIdColumn, 
    saveUpdates, csvIt, deCsvHeader, deHeader, deHiddenColumns, myUpdateApi}) {
    const [myTableData, setMyTableData] = useState([]);

    useEffect(() => {
        setMyTableData(tableData);
    }, [tableData]);

    const [changes, setChanges] = useState({});
    const [checkStates, setCheckStates] = useState({});
    const [selectionLabels, setSelectionLabel] = useState([]);
    const [newState, setNewState] = useState("");

    //laden der checkboxes/states und möglichen neuen Status
    useEffect(() => {
        const auth = sessionStorage.getItem('token');
        var accessedData = [];
        if (auth.includes('level2')) {
            accessedData = myTableData;
        } else if (auth.includes('level1')) {
            accessedData = myTableData.filter(data => data.statusEnum !== "FIX");
            setSelectionLabel([
                {id: "FREI", text: 'in Bearbeitung -> freigegeben'},
                {id: "FREI", text: 'zur Korrektur -> freigegeben'},
                {id: "KORREKTUR", text: 'freigegeben -> zur Korrektur'},
                {id: "FIX", text: 'freigegeben -> fixiert'}
            ]);
        } else {
            accessedData = myTableData.filter(data => data.statusEnum === "BEARBEITUNG" || data.statusEnum === "KORREKTUR");
            setSelectionLabel([
                {id: "FREI", text: 'freigegeben'}
            ]);
        }
        setCheckStates([]); //leeren, um nur angezeigte Zeilen zu sammeln!
        accessedData.forEach(e => {
            setCheckStates(pre => ({...pre, [e[`${nameOfIdColumn}`]]: false}))
        });
    }, [myTableData, nameOfIdColumn])
    
    
        //alle States auswählen
    const selectAll = (event, state) => {
        event.preventDefault();
        setNewState("");
        myTableData.forEach(s => 
            setCheckStates(pre => 
                ({...pre, [s[`${nameOfIdColumn}`]]: state})
            )
        );
    }
    
        //einzelne states wählen
    const selectOne = (index) => {
        const currentId = myTableData[index][`${nameOfIdColumn}`];
        setCheckStates(pre => ({...pre, [currentId]: !checkStates[currentId]}));
    }
    
    const addStateChange = event => {
        setNewState(event.target.value);
    }
    
        //eingetragene Änderungen merken und in Liste zusammenführen
    const update = (index, id, value) => {
        const currentId = parseInt(myTableData[index][`${nameOfIdColumn}`]);
        const before = changes[currentId];
        if (before) {
            before[id] = value;
            setChanges(pre => ({...pre, [currentId]: before}));
        } else {
            setChanges(pre => ({...pre, [currentId]: {[id]: value}}));
        }
    }
 
    //Statusänderung in changes integrieren
    const combineFilterAndStatus = (givenNewState, givenCheckStates) => {
        const currentChanges = changes;
        Object.keys(givenCheckStates).filter(s => givenCheckStates[s]).forEach(
            idrow => {
                const before = changes[idrow];
                if (before) {
                    before['status'] = givenNewState; 
                    currentChanges[idrow] = before;
                } else {
                    currentChanges[idrow] = {'status': givenNewState};
                }
            }
        );
        return currentChanges;
    }

        //speichern der geänderten Inputs
    const savingProcess = () => {
        var allUpdates = [];
        setChanges(combineFilterAndStatus(newState, checkStates));

        Object.keys(changes).forEach(deObj => {
            var myUpdate = myUpdateApi();
            myUpdate[`${nameOfIdColumn}`] = deObj;
            for (const [key, value] of Object.entries(changes[deObj])) {
                myUpdate[key] = value;
                }  
            allUpdates.push(myUpdate);
        })

        saveUpdates(allUpdates, setNewState, setChanges, checkStates, setCheckStates);
    }
 
    
        //gelöschte Änderungen verwerfen
    const deleteChange = (index) => {
        const currentId = myTableData[index][`${nameOfIdColumn}`];
        const pre = {...changes};
        delete pre[currentId];
        setChanges(pre);
    }
    
    return (
        <div>
            {loading && <DatenLaden/>}
            {myTableData.length > 0 && <div  className="vvd">
                <TableWithInputsAndFilter data={myTableData} columns={deHeader} hiddenColumns={deHiddenColumns} 
                            updateMethod={update} deleteChange={deleteChange} whichDe={"bhfdaten"} deleteSpecificRow={deleteSpecificRow}
                            registerStateChange={selectOne} selectAll={selectAll} states={checkStates}/>
                {noData && <label>---Keine Daten für diese Filterung---</label>}
                <div className="vvd-not-table">
                    <div className = "vvd-import-export">
                        <CSVLink data={csvIt(myTableData)} headers={deCsvHeader} separator={";"} target="_blank" filename="export-BhfDaten-gefiltert.csv">
                            Gefilterte Daten exportieren
                        </CSVLink>
                        {/* //TODO Import einfügen*/}
                    </div>

                    <div className="vvd-state-change">
                        {Object.values(checkStates).filter(obj => obj).length > 0 && <div className="update-status">
                                <label>neuen Status setzen: </label>
                                <select onChange={addStateChange}>
                                    <option hidden value={""}>---neuer Status---</option>
                                    {selectionLabels.map(label => <option key={label.id} value={label.id}>{label.text}</option>)}
                                </select>
                                <p>Aktuell ausgewählte Einträge: {Object.values(checkStates).filter(e => e).length}</p>
                            </div>}

                        {(newState.length > 0 || Object.keys(changes).length > 0) && <div className="vvd-save"><button onClick={savingProcess}>Änderungen übernehmen</button></div>}
                    </div>
                    </div>
            </div>}
            {noData && <KeineDaten/>}
        </div>
    )
}